export const KOLMEO_EMAIL_TEMPLATE = {
  to: 'help@kolmeo.com',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello Kolmeo

Could you please enable Snug as an upload destination for our agency for the Kolmeo Account(s):

- [Enter your Agency ID here]

Please assign the Kolmeo Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
